











 








const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AtlassianProviderRowAtlassianIntegration",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accessToken",
      "storageKey": null
    }
  ],
  "type": "AtlassianIntegration",
  "abstractKey": null
};

(node ).hash = "7a41fc110305ab39cbec2b1302a8a1ec";

export default node;
